import { createAppUpdate, watchAppVersion } from '@jaluzi/ui';
export const appUpdate = createAppUpdate();

export function startAppUpdateFallback() {
  if (import.meta.env.PROD && !('serviceWorker' in navigator)) {
    watchAppVersion(appUpdate, __APP_BUILD_ID__);
  }
}
